var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canBeDeleted)?_c('div',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.showConfirmationModal()}}},[_c('i',{staticClass:"fas fa-fw fa-trash-alt text-danger"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }